import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import SarasButton from '../../library/input/buttons/button/SarasButton';
import SarasCssBaseline from '../../library/decor/cssBaseline/SarasCssBaseline'
import SarasTextField from '../../library/input/textField/SarasTextField'
import SarasLink from '../../library/input/link/SarasLink'
import SarasTypography from '../../library/decor/typography/SarasTypography' 
import {attemptSignIn} from './store/actions/action';
import CheckSignStatus from './CheckSignStatus';
import SarasTrans from '../../library/notifications/SarasTrans';
import GoogleLogin from './sso/GoogleLogin';
import SarasErpApi from '../../helper/SarasErpApi';
import logo from '../../logo/sarasx-logo-poweredby-dark-bg.svg';

function Copyright() {
  return (
    <SarasTypography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <SarasLink color="inherit" target="_blank" href="https://sarasennovations.com" text="SARAS ennovations">
      </SarasLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </SarasTypography>
  );
}

const SignIn = () => {
    const [email, setEmail] = useState('');
    const [pass, setPassword] = useState('');
    const [providers, setProviders] = useState(null);

    const dispatchLogin = useDispatch();
    
    const onEmailChange = (e) => {
      setEmail(e.target.value);
    }

    const onPassChange = (e) => {
      setPassword(e.target.value);
    }

    const onSubmit = (event) => {
      event.preventDefault();

      // call action reducer
      dispatchLogin(attemptSignIn(email, pass));
    }

    const initialisePath = () => {
      if(providers == null){
          //request for providers from the server, if none are available then expect "na"
          SarasErpApi.get('sso/getproviders').then((response) => {
            // console.log("sso", response && response.data);
            setProviders((response && response.data) || "na");
        });
      }
  };
  
  useEffect(initialisePath, [providers]);

      return (
        <>
          <CheckSignStatus />
          <SarasCssBaseline />
          <div className="uiSignInWrapper">
            <div className="uiSignInPaper">
                <div container="true" className="uiLogoContainer">
                    <img src={logo} className="App-logo" alt="SarasX" />
                </div>
                <form onSubmit={onSubmit} noValidate className="uiForm">
                  <h1 className="uiSignInTitle" component="h1" variant="h5"><SarasTrans value = "Sign in with Password"/></h1>
                  <label className="uiSigninLabel" htmlFor="loginid">Login ID</label>
                  <SarasTextField className="uiSigninInput" margin="normal" required fullWidth name="loginid"
                    autoComplete="loginid" autoFocus value={email} onChange={onEmailChange} 
                    placeholder="Enter your login ID"
                  />
                  <label className="uiSigninLabel" htmlFor="password">Password</label>
                  <SarasTextField className="uiSigninInput" margin="normal" required fullWidth name="password" type="password"
                    autoComplete="current-password" value={pass} onChange={onPassChange}
                    placeholder="Enter your password"
                  />
                  <SarasButton 
                    starIcon="signin"  
                    starIconClassName=" "
                    type="submit" fullWidth variant="contained" color="primary" className="uiSubmit" text='Sign In'/>
                  {providers ? 
                    <><h1 className="uiSignInTitle uiBrandColor3" component="h1" variant="h5"><SarasTrans value = "Alternate Option"/></h1>
                    <GoogleLogin providers={providers}/></>
                  : null}
                </form>
                <Copyright />
              </div>
            </div>
          </>
      );
  }

export default SignIn;